import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-badge",
  templateUrl: "./badge.component.html",
  styleUrls: ["./badge.component.scss"],
})
export class BadgeComponent implements OnInit {
  @Input() label: string = "";
  @Input() className: string;
  @Input() labelTranslationKey: string;
  @Input() labelTranslationModuleEnum: number;
   @Input() backgroundColor: string;
  @Input() rejectReason: string = "";
  // @Input() backgroundColor: string = "";
  constructor() {}

  ngOnInit(): void {}
}
